"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _atom = require("atom");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var Alerts = _interopRequireWildcard(require("customer-data-ui-utilities/alerts/Alerts"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _immutable = require("immutable");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _utils = require("reference-resolvers/utils");

var propTypes = (0, _extends2.default)({}, _UITextInput.default.propTypes, {
  autoFocus: _react.PropTypes.bool,
  onInvalidProperty: _react.PropTypes.func.isRequired,
  propertyIndex: _react.PropTypes.number,
  showError: _react.PropTypes.bool,
  value: _react.PropTypes.string,
  subjectId: _react.PropTypes.string,
  resolver: _ReferenceResolverType.default,
  className: _react.PropTypes.string,
  size: _react.PropTypes.object,
  suppressAlerts: _react.PropTypes.bool
});
var defaultProps = (0, _extends2.default)({}, _UITextInput.default.defaultProps, {
  size: {
    xs: 12
  },
  className: 'p-x-0',
  wrapperClassName: 'p-left-0',
  onInvalidProperty: _emptyFunction.default
});
var initialState = {
  contactReference: null
};

var PropertyInputEmail =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputEmail, _React$Component);

  function PropertyInputEmail() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputEmail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputEmail).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = initialState;
    _this.referenceAtom = null;
    return _this;
  }

  (0, _createClass2.default)(PropertyInputEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var resolver = _ref.resolver,
          subjectId = _ref.subjectId,
          onInvalidProperty = _ref.onInvalidProperty,
          value = _ref.value,
          hasBlurred = _ref.hasBlurred;
      var propertyValue = value ? value.trim() : null;

      if (!value === this.props.value || !(0, _PropertyValidations.isValidEmail)(propertyValue) || !value || !subjectId || !resolver) {
        return null;
      }

      this.unwatchReferenceAtom();
      this.referenceAtom = resolver.byId(propertyValue);
      (0, _atom.watch)(this.referenceAtom, this.handleContactReferenceChange);
      this.handleContactReferenceChange((0, _atom.deref)(this.referenceAtom));
      var contactReference = this.state.contactReference;

      if ((0, _utils.isResolved)(contactReference) && hasBlurred) {
        if (contactReference.referencedObject && "" + contactReference.referencedObject.get('vid') !== subjectId) {
          onInvalidProperty(true);
          this.showAlert(value);
        } else {
          onInvalidProperty(false);
        }
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unwatchReferenceAtom();
    }
  }, {
    key: "unwatchReferenceAtom",
    value: function unwatchReferenceAtom() {
      if (this.referenceAtom) {
        (0, _atom.unwatch)(this.referenceAtom, this.handleContactReferenceChange);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
      this.refs.input.select();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.props.value;
      return value ? value.trim() : '';
    }
  }, {
    key: "handleContactReferenceChange",
    value: function handleContactReferenceChange(contactReference) {
      this.setState({
        contactReference: contactReference
      });
    }
  }, {
    key: "shouldShowError",
    value: function shouldShowError() {
      var _this$props = this.props,
          showError = _this$props.showError,
          hasBlurred = _this$props.hasBlurred;
      var propertyValue = this.getValue();
      return showError && hasBlurred && propertyValue && !!propertyValue.length && !(0, _PropertyValidations.isValidEmail)(propertyValue);
    }
  }, {
    key: "showAlert",
    value: function showAlert(value) {
      if (this.props.suppressAlerts) {
        return null;
      }

      var baseUrl = this.props.baseUrl;
      var id = "nonunique-email-" + value;
      var message = 'profileSidebarModule.contactAlreadyExists';
      var options = {
        profileUrl: "" + baseUrl + value,
        email: value
      };
      return Alerts.addError(message, options, {
        id: id
      });
    }
  }, {
    key: "isUniqueEmail",
    value: function isUniqueEmail(record) {
      var _this$props2 = this.props,
          subjectId = _this$props2.subjectId,
          hasBlurred = _this$props2.hasBlurred;

      if (!hasBlurred) {
        return true;
      }

      if (record.referencedObject && "" + record.referencedObject.get('vid') !== subjectId) {
        return false;
      }

      return true;
    }
  }, {
    key: "renderValidationError",
    value: function renderValidationError() {
      if (!this.shouldShowError()) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "is--text--error p-top-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInput.errorMessageInvalidEmail"
      }));
    }
  }, {
    key: "renderNonUniqueError",
    value: function renderNonUniqueError() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          baseUrl = _this$props3.baseUrl,
          subjectId = _this$props3.subjectId,
          hasBlurred = _this$props3.hasBlurred,
          resolver = _this$props3.resolver;
      var propertyValue = this.getValue();

      if (!(0, _PropertyValidations.isValidEmail)(propertyValue) || !value || !subjectId || !hasBlurred || !resolver) {
        return null;
      }

      var contactReference = this.state.contactReference;

      if (!(0, _utils.isResolved)(contactReference) || this.isUniqueEmail(contactReference)) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "is--text--error p-top-2"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInput.errorMessageNonUniqueEmail",
        options: {
          email: propertyValue,
          profileUrl: "" + baseUrl + propertyValue
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          autoFocus = _this$props4.autoFocus,
          size = _this$props4.size;
      var transferableProps = (0, _omit.default)(['actions', 'baseUrl', 'hasBlurred', 'handleBlur', 'handleFocus', 'isInline', 'getProperty', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'resolver', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'wrapperClassName', 'suppressAlerts', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();
      return _react.default.createElement(_UIGridItem.default, {
        size: size,
        className: "p-x-0"
      }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, transferableProps, {
        "data-modalfocus": autoFocus,
        name: "textInput",
        value: this.getValue(),
        ref: "input",
        onBlur: this.props.handleBlur,
        onFocus: this.props.handleFocus,
        error: this.shouldShowError() || !!this.renderNonUniqueError()
      })), this.renderValidationError(), this.renderNonUniqueError());
    }
  }]);
  return PropertyInputEmail;
}(_react.default.Component);

exports.default = PropertyInputEmail;
PropertyInputEmail.propTypes = propTypes;
PropertyInputEmail.defaultProps = defaultProps;
module.exports = exports.default;